
// Creating namespace
var SellsyJS = (function() {

    var initialized = false;

    /*
     * Initialization function
     */
    function init(params) {

        /*
            Initialize from server's params:
                base url
                locale to use
                identity of the loggedin user
                etc etc
        */
        if (initialized) {
            return true;
        }

        $(document).trigger(SellsyJS.Events.AppInit);
        return true;
    }

    /**
     * @access public static
     */
    return {
        // Methods
        init: init
    }
})();


SellsyJS.Events = (function() {

    /*
     * Execute a method only if initialzed var is ready
     */
    function executeIfReady(call, initialized, trigger, onError) {

        var toExecute = function toExecute() {
            try {
                call();
            } catch (e) {
                if (onError) {
                    onError(e);
                } else {
                    // TODO dedicated error system
                }
            }
        };

        if (initialized) {
            setTimeout(toExecute, 0); // in order to detach the callee
        } else {
            $(document).one(trigger, toExecute);
        }
    }
    return {
        AppInit: 'AppInit',
        AjaxDone: 'AjaxDone',
        AxiosInit: 'AxiosInit',


        executeIfReady: executeIfReady
    }
})();


SellsyJS.WebServiceCaller = (function() {

    var QUERY_TIMEOUT = 120000;

    var currentQuery = false;
    var initialized = false;
    var stack = [];

    var axiosInstance = null;
    var csrfToken = null;

    var webServiceParamsDefaultValues = {
        concurrent: false,
        stack: true,
        params: {},
        data: {},
        error_callback: $.noop,
        success_callback: $.noop,
        method: 'GET'
    };

    function _unstackQuery() {
        if (stack.length > 0) {
            var query = stack.pop();
            callWebService(query);
        }
    }

    function init() {
        // axios setup
        if (initialized) {
            return true;
        }

        axiosInstance = axios.create({
            //baseURL: , // @TODO : initialize Js with erver values for base url ( saas hots )
            timeout: QUERY_TIMEOUT,
            headers: {'X-Requested-With': "XMLHttpRequest", 'X-REQUESTED-WITH-AXIOS': 1, 'X-SAAS-WEBSERVICE': 1},
            xsrfHeaderName: 'X-CSRF-TOKEN'
        });

        var csrf = $('meta[name="saas-csrf-token"]').attr('content');
        if (csrf) {
            csrfToken = csrf;
        }
        let lastRequestId = $('meta[name="x-request-id"]').attr('content');
        window.axios.defaults.headers.common['X-LAST-REQUEST-ID'] = lastRequestId;
        EventBus.emit('on-new-request-id', lastRequestId);

        $(document).trigger(SellsyJS.Events.AxiosInit);
        return true;
    }

    function onResponse(response) {
        currentQuery = false;
        if ('headers' in response) {
            if ('x-csrf-token' in response.headers) {
                let csrfToken = response.headers['x-csrf-token'];
                $('meta[name="saas-csrf-token"]').attr('content', csrfToken);
                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
            }
            if ('x-request-id' in response.headers) {
                let requestId = response.headers['x-request-id'];
                $('meta[name="x-request-id"]').attr('content', requestId);
                window.axios.defaults.headers.common['X-LAST-REQUEST-ID'] = requestId;
                EventBus.emit('on-new-request-id', requestId);
            }
        }
    }
    /**
     *  callWebService: in charge of web services calls
     *  @return: void
     *  @params: All params are optionnal except 'route', the route to hit on server side.
     *           route (string): the action to execute on server side
     *           params (array): the URL parameters ( to be appended )
     *           data (array) : the data to give as the request payload ( POST web services )
     *           method: GET / POST / DELETE / PUT / PATCH / OPTIONS
     *           stack (bool): anti 'double clic', check that no others request is running, and stack the Web serice call if other request is running
     *           concurrent (bool): is there possibly others requests running the same time?
     *           success_callback (function): the callback to be called after a successfull request
     *           error_callback (function): the callback to be called after a failure
     */
    function callWebService(params) {

        // Check params
        if (!params.route) {
            return false;
        }

        params = $.extend(true, {}, webServiceParamsDefaultValues, params);

        if (currentQuery && !params.concurrent) {
            if (params.stack === true) {
                stack.push(params);
                return true;
            } else {
                if (params.error_callback) {
                    params.error_callback();
                }
                return false;
            }
        }

        var onDone = function onDone(response) {
            onResponse(response);

            try {
                var success = response && response.data != undefined;

                if (!success && params.error_callback) {
                    params.error_callback();
                }
                if (success && params.success_callback) {
                    if (params.success_callback.headers) {
                        params.success_callback.callback(response);
                    } else {
                        params.success_callback(response.data);
                    }
                }

                $(document).trigger(SellsyJS.Events.AjaxDone);
            } catch (e) {
                // TODO: dedicated error logger on client side
            }
            _unstackQuery();
        };

        var onError = function onError(data) {
            onResponse(data);

            try {
                if (data.response && data.response.status == 401 && data.response.data && data.response.data.status == 'logout'){
                    window.location.reload();
                    return false
                }
                if (params.error_callback) {
                    params.error_callback(data);
                }
            } catch (e) {
                // TODO: dedicated error logger on client side
            }
            _unstackQuery();
        };

        var onFinally = function onFinally() {

        };

        return _ajaxCall(params.route, params.params, params.data, params.method, onDone, onError, onFinally);
    }

    function post(route, params, data, onDone, onError, onFinally) {

        return callWebService({route: route, params: params, data: data, method: 'POST', success_callback: onDone, error_callback: onError, finally_callback : onFinally});
    }

    function patch(route, params, data, onDone, onError, onFinally) {

        return callWebService({route: route, params: params, data: data, method: 'PATCH', success_callback: onDone, error_callback: onError, finally_callback : onFinally});
    }

    function put(route, params, data, onDone, onError, onFinally) {

        return callWebService({route: route, params: params, data: data, method: 'PUT', success_callback: onDone, error_callback: onError, finally_callback : onFinally});
    }

    function get(route, params, onDone, onError, onFinally) {

        return callWebService({route: route, params: params, method: 'GET', success_callback: onDone, error_callback: onError, finally_callback : onFinally});
    }

    function del(route, params, onDone, onError, onFinally) {
        return callWebService({route: route, params: params, method: 'DELETE', success_callback: onDone, error_callback: onError, finally_callback : onFinally});
    }

    function sendBeacon(route, params) {
        return navigator.sendBeacon(route, params);
    }


    function _ajaxCall(url, params, data, method, onDone, onError, onFinally) {
        init();
        let controller = new AbortController();
        let promise = axiosInstance.request({
            url: url,
            params: params,
            method: method,
            data: data,
            headers: {'X-CSRF-TOKEN': csrfToken},
            signal: controller.signal
        });
        if (promise) {
            promise.abort = () => controller.abort();

            promise.then(function(response) {
                onDone(response);
                return response;
            });
            promise.catch(function(error) {
                if (error.name !== 'AbortError') {
                    /**
                     * Due to backward compatibility, onError callback can not be removed without refactoring a lot.
                     * So error is just thrown again to make it catchable on higher level.
                     */
                    onError(error);
                    throw error;
                }
            });
            promise.finally(function() {
                onFinally()
            });
        }
        return promise;
    }

    /**
     * @access public static
     */
    return {
        init: init,
        callWebService: callWebService,
        post: post,
        get: get,
        patch : patch,
        put : put,
        del : del,
        sendBeacon: sendBeacon
    };

})();

window.SellsyJS = SellsyJS;
